export function getFallbackStateInventory({ isLoading, allItems, filteredItems }) {
  if (isLoading) return { state: "loading" };
  if (!allItems || allItems.length === 0) return { state: "noData" };
  if (filteredItems.length === 0) return { state: "noMatch" };
  return { state: "ok" };
}
